module.exports = __webpack_public_path__ + "media/images/icare-life-82014b4cd6d646630c5a0d707c286408.png";